import React from 'react';
export default function Footer() {
    return (
       <>
       <footer id="footer">
    <div className="container">
      <div className="copyright">
        &copy; Copyright <strong><span>HP Transcoders</span></strong>
      </div>
      <div className="credits">
        Designed by <a href="https://hptranscoders.com/harsh-nirbhavane" target="_blank"> Harsh</a>
      </div>
    </div>
  </footer>
  <a href="#" className="back-to-top"><i className="icofont-simple-up"></i></a>
  
       </>
    )
}
